import { IYearSelectOption } from 'CorePackage/MainModule/interfaces/IYearSelectOption';

export const createKnmYearSelectOption = (knmYear: number): IYearSelectOption => ({
  id: knmYear.toString(),
  label: knmYear.toString(),
  value: knmYear.toString(),
});
